
import './App.css';
import Contact from './components/contact/Contact';
import Footer from './components/footer/Footer';
import Journey from './components/journey/Journey';
import Navbar from './components/navbar/Navbar';
import Projects from './components/projects/Projects';
import Scroll from './components/scroll/Scroll';

function App() {
  return (
    <div className="App">
      <Navbar />

      <div id="home">
        <Scroll />
      </div>

      <div id="about">
        <Journey />
      </div>

      <div id="projects">
        <Projects />
      </div>

      <div id="contact">
        <Contact />
      </div>

      <Footer />
    </div>
  );
}

export default App;
